import { PropsWithChildren } from 'react'
import { Outlet } from 'react-router-dom'

import { useAnchor } from '../../hooks/location'
import SideBar from '../side-bar/SideBar'
import Header from '../common/Header'
import { Column, Row } from '../common/pure/FlexContainer'

export default function PrivateRoot() {
    useAnchor()

    return (
        <PrivateContextStack>
            <Row container>
                <SideBar />
                <Column grow scroll>
                    <Header />
                    <Column grow className="content-container">
                        <Outlet />
                    </Column>
                </Column>
            </Row>
        </PrivateContextStack>
    )
}

import DeviceProvider from '../contexts/DeviceContext'
import SensorProvider from '../contexts/SensorContext'
import CalibrationRodProvider from '../contexts/CalibrationRodContext'
import StructureProvider from '../contexts/StructureContext'
import ProjectProvider from '../contexts/ProjectContext'
import BoltConnectionProvider from '../contexts/BoltConnectionContext'
import BoltProvider from '../contexts/BoltContext'
import WorkfileProvider from '../contexts/WorkfileContext'
import ExportProvider from '../contexts/ExportContext'
import SearchProvider from '../contexts/SearchContext'
import ServiceWindowProvider from '../contexts/ServiceWindowContext'

const PrivateContextStack = ({ children }: PropsWithChildren) => (
    <SearchProvider>
        <DeviceProvider>
            <SensorProvider>
                <CalibrationRodProvider>
                    <StructureProvider>
                        <ProjectProvider>
                            <BoltConnectionProvider>
                                <BoltProvider>
                                    <WorkfileProvider>
                                        <ExportProvider>
                                            {/* prettier-ignore */}
                                            <ServiceWindowProvider>{children}</ServiceWindowProvider>
                                        </ExportProvider>
                                    </WorkfileProvider>
                                </BoltProvider>
                            </BoltConnectionProvider>
                        </ProjectProvider>
                    </StructureProvider>
                </CalibrationRodProvider>
            </SensorProvider>
        </DeviceProvider>
    </SearchProvider>
)
